export enum CheckingParams {
  view = '/:view(checking)',
  moduleResult = '/:module(result)',
  moduleTest = '/:module(test)',
  channel = '/:channel(sms|hlr|smsBeta)',
  channelSms = '/:channel(sms)',
  channelHlr = '/:channel(hlr)',
  mode = '/:mode(single|mass)',
}
